import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  organizationsdata: [],
  pageIndex: 1,
  deleted: false,
  filter: undefined,
  count: 0,
  size: 10,
  search: undefined,
  sortOrg: [
    {
      id: 'name',
      sort: true,
      desc: false
    }
  ]
};

const organizationsdata = createSlice({
  name: 'organizationsdata',
  initialState,
  reducers: {
    updateorganizationsdata(state, action) {
      state.organizationsdata = action.payload;
    },
    setorganizationsdataSearch(state, action) {
      state.search = action.payload;
    },
    setOrganizationTotalCount(state, action) {
      state.count = action.payload;
    },
    setorganizationsdatastatus(state, action) {
      state.deleted = action.payload;
    },
    setorganizationsdataFilterType(state, action) {
      state.filter = action.payload;
    },
    setorganizationsdataPageIndex(state, action) {
      return {
        ...state,
        pageIndex: action.payload
      };
    },
    delorganizationsdata(state: any, action) {
      state.organizationsdata.data = state.organizationsdata.data.filter((item: { _id: any }) => item._id !== action.payload);
    },
    setorganizationsdataTableSize(state, action) {
      return {
        ...state,
        size: action.payload
      };
    },
    resetStateorganizationsdata: (state) => {
      return initialState;
    },
    setOrganizationSorting(state, action) {
      state.sortOrg = action.payload;
    }
  }
});

export const {
  updateorganizationsdata,
  setorganizationsdataSearch,
  setOrganizationTotalCount,
  setorganizationsdatastatus,
  setorganizationsdataPageIndex,
  setorganizationsdataFilterType,
  delorganizationsdata,
  setorganizationsdataTableSize,
  resetStateorganizationsdata,
  setOrganizationSorting
} = organizationsdata.actions;
export default organizationsdata.reducer;
